<ng-container *ngIf="!datos.tipo">
  <h2 mat-dialog-title>{{'EDITOR.ELEMENTOS.ETIQUETAS.INTERFAZ.MODAL.TITULO' | translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <p><em>{{'EDITOR.ELEMENTOS.ETIQUETAS.INTERFAZ.MODAL.SUBTITULO' | translate}}</em></p>
    <mat-list>
      <mat-radio-group  [(ngModel)]="idiomaElegido">
        <ng-container *ngFor="let idioma of datos.idiomas; let last = last;">
          <ng-container *ngIf="idioma.id != datos.idiomaActual">
            <mat-list-item>
              <mat-radio-button value="{{idioma.id}}">{{'NOMBREIDIOMAS.'+idioma.id | translate}}</mat-radio-button>
            </mat-list-item>
            <mat-divider *ngIf="!last"></mat-divider>
          </ng-container>
        </ng-container>
      </mat-radio-group>
    </mat-list>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      {{'EDITOR.ELEMENTOS.BOTONES.CANCELAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
    <button *ngIf="idiomaElegido" mat-raised-button color="primary" class="mt-20 dialog_confirmar" (click)="salir()" cdkFocusInitial>
      {{'EDITOR.ELEMENTOS.BOTONES.CONTINUAR' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>
  </div>
</ng-container>
<ng-container *ngIf="datos.tipo == 'dominio'">
  <h2 mat-dialog-title>{{'EDITOR.ELEMENTOS.ETIQUETAS.INTERFAZ.DOMINIO.TITULO' | translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <p><em>{{'EDITOR.ELEMENTOS.ETIQUETAS.INTERFAZ.DOMINIO.ACTIVAR' | translate}}</em></p>
      <div fxLayout="row" fxLayoutAlign="start center" class="mb-20">
        <p>{{'EDITOR.ELEMENTOS.BOTONES.NO' | translate}}</p>
        <mat-slide-toggle [(ngModel)]="infoDominio.enable" class="ml-20 mr-20"></mat-slide-toggle>
        <p>{{'EDITOR.ELEMENTOS.BOTONES.SI' | translate}}</p>
      </div>
      <p><em>{{'EDITOR.ELEMENTOS.ETIQUETAS.INTERFAZ.DOMINIO.DOMINIO' | translate}}</em></p>
      <mat-form-field appearance="outline">
        <mat-label>{{'EDITOR.ELEMENTOS.ETIQUETAS.INTERFAZ.SELOPC' | translate}}</mat-label>
        <!-- <mat-select [(ngModel)]="infoDominio.url">
          <mat-option *ngFor="let opcionLista of datos.dominios" [value]="opcionLista.opcion">
            {{opcionLista.opcion}}
          </mat-option>
        </mat-select> -->
        <input matInput [(ngModel)]="infoDominio.url">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salirConfig()">
      {{'EDITOR.ELEMENTOS.BOTONES.REGRESAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
  </div>
</ng-container>
